// firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getDatabase } from 'firebase/database';

function normalizeUrlBase(value, fallback) {
  return String(value || fallback || '').trim().replace(/\/+$/, '');
}

// Firebase configuration
const DEFAULT_FIREBASE_CONFIG = {
  apiKey: 'AIzaSyDePWJ0qJ91y3_VfLVeFb1dCA_Iqa5MEYY',
  appId: '1:902827358957:web:b8a3913e74cf9a8cc22ae4',
  authDomain: 'dropspot-main.firebaseapp.com',
  databaseURL: 'https://dropspot-main-default-rtdb.firebaseio.com/',
  measurementId: 'G-5WKWFDMGQ4',
  messagingSenderId: '902827358957',
  projectId: 'dropspot-main',
  storageBucket: 'dropspot-main.firebasestorage.app',
};

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || DEFAULT_FIREBASE_CONFIG.apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || DEFAULT_FIREBASE_CONFIG.authDomain,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || DEFAULT_FIREBASE_CONFIG.projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || DEFAULT_FIREBASE_CONFIG.storageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || DEFAULT_FIREBASE_CONFIG.messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE_APP_ID || DEFAULT_FIREBASE_CONFIG.appId,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || DEFAULT_FIREBASE_CONFIG.measurementId,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || DEFAULT_FIREBASE_CONFIG.databaseURL,
};

const FIREBASE_FUNCTIONS_REGION = process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || 'us-central1';
const FIREBASE_PROJECT_ID = firebaseConfig.projectId;
const APP_BASE_URL = normalizeUrlBase(
  process.env.REACT_APP_APP_BASE_URL || process.env.REACT_APP_PUBLIC_APP_ORIGIN,
  'https://dropspot.live'
);
const FUNCTIONS_BASE_URL = normalizeUrlBase(
  process.env.REACT_APP_FUNCTIONS_BASE_URL,
  `https://${FIREBASE_FUNCTIONS_REGION}-${FIREBASE_PROJECT_ID}.cloudfunctions.net`
);

function buildFunctionUrl(functionName) {
  const cleanedFunctionName = String(functionName || '').trim().replace(/^\/+/, '');
  return `${FUNCTIONS_BASE_URL}/${cleanedFunctionName}`;
}

// 🔊 add this line:
//setLogLevel('debug');

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
const auth = getAuth(app);

// Initialize Firestore
const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
  useFetchStreams: false,
});

// Initialize Firebase Storage
const storage = getStorage(app);

// Initialize Firebase Functions
const functions = getFunctions(app, FIREBASE_FUNCTIONS_REGION);

// Initialize Firebase Realtime Database
const realTimeDb = getDatabase(app);

// Centralized collection names
const collections = {
  automations: "_automations",
  checklists: "_checklists",
  checklistRecords: "_checklist_runs",
  collections: "_databases",
  dashboards: "_dashboards",
  dictionary: "_dictionary",
  edges: "_edges",
  events: "_events",
  engagements: "_engagements",
  icons: "_icons",
  layouts: "_layouts",
  pages: "_pages",
  pins: "_pins",
  nodes: "_nodes",
  nodetypes: "_nodetypes",
  nodeChangeNotificationBatches: "_node_change_notification_batches",
  notifications: "_notifications",
  plans: "_plans",
  portals: "_portals",
  purchases: "_purchases",
  redemptions: "_redemptions",
  settings: "_settings",
  songs: "_songs",
  storagelogs: "_storagelogs",
  streamlogs: "_streamlogs",
  subscriptions: "_subscriptions",
  templates: "_templates",
  tickets: "_tickets",
  nodeviews: "_nodeviews",
  views: "_views",
  modules: "_modules",
  workspaces: "_workspaces",
  workspaceBilling: "_workspace_billing",
  workspaceInvites: "_workspace_invites",
  workspaceInviteTokens: "_workspace_invite_tokens",
};

export {
  APP_BASE_URL,
  FIREBASE_PROJECT_ID,
  FIREBASE_FUNCTIONS_REGION,
  FUNCTIONS_BASE_URL,
  app,
  auth,
  buildFunctionUrl,
  collections,
  db,
  functions,
  httpsCallable,
  realTimeDb,
  storage,
};
